import React from 'react';
import Labels from '../../variables/labels';
import welcomeLogoAnimation from 'assets/images/animations/welcome-logo-animation.gif';

const Loader = (props) => {
  const { message, inverted, local, big, small, height, branding = false } = props;
  const useFullHeight = branding && !local;
  const containerHeight = height || (useFullHeight ? '100vh' : '100px');
  return (
    <div style={{ height: containerHeight }}>
      <div
        className={`ui ${useFullHeight ? 'page' : ''} active dimmer ${inverted ? "inverted" : ""} ${local ? "local" : ""} ${small ? "small" : ""}`}
        style={{ height: containerHeight, position: 'relative' }}
      >
        {(branding) && (
          <style>{`
            /* Dissolving white mask overlay */
            .brand-mask {
              position: absolute;
              inset: 0;
              background: rgba(255, 255, 255, 1);
              pointer-events: none;
              z-index: 2;
              animation: brand-mask-dissolve 2000ms cubic-bezier(0.55, 0, 0.8, 0.6) forwards;
            }
            @keyframes brand-mask-dissolve {
              0% { opacity: 1; }
              30% { opacity: 1; }
              100% { opacity: 0; }
            }
          `}</style>
        )}
        {(branding) ? <div className="brand-mask" key={`mask-${branding}`} /> : null}
        {branding ? (
          <div className="content" style={{ zIndex: 1 }}>
            <div className="center" style={{ display:'flex', alignItems:'center', justifyContent:'center' }}>
              <img
                src={welcomeLogoAnimation}
                alt="brand-animation"
                style={{ display: 'block', width: big ? 220 : 160, height: big ? 220 : 160, objectFit: 'contain' }}
              />
            </div>
          </div>
        ) : (
          <div className={`ui text loader ${big ? "big" : ""}`}>{message}</div>
        )}
      </div>
    </div>
  );
}

Loader.defaultProps = {
  message: Labels.loaderMessage,
  inverted: true,
  big: true,
  local: false,
}
export default Loader;